export const claimsAdvicePaymentHistoryColumns = [
  'id',
  'fk_claims_advice_meta_data_id',
  'claim_number',
  'claim_status_code',
  'claim_filing_indicator_code',
  'internal_control_number',
  'type_of_bill_summary',
  'type_of_bill_frequency',
  'drg',
  'drg_weight',
  'discharge_fraction',
  'exchange_rate',
  'source_pay_type_code',
  'claim_refs',

  'patient_last_name',
  'patient_first_name',
  'patient_middle_name',
  'delimiter',
  'trx_key',
  'meta_lineage_source_system_name',
  'meta_lineage_source_name',
  'meta_lineage_source_offset',
  'meta_load_dt',
  'meta_correlation_id',
  'meta_component',
  'snapshot_id',
  'claim_reported_charge',
  'claim_payment_amt',
  'claim_monetary_amt',
];
